// extracted by mini-css-extract-plugin
module.exports = {"learn_more":"learn_more-module--learn_more--35f9h","learn_more__btn":"learn_more-module--learn_more__btn--3W4JZ"};